export const applySearchFilter = (options: any[], searchBy: string) => {
  return options.filter((option: (string | number)[]) => {
    return option?.toString().toLowerCase().includes(searchBy.toLowerCase());
  });
};
